export default "__VITE_ASSET__D5JaRom7__"